<wp-user-profile-info [editDisabled]="false"> </wp-user-profile-info>

<wp-user-profile-change-password-preview [disabled]="false"> </wp-user-profile-change-password-preview>
